module.exports = __webpack_public_path__ + "img/aboutbanner.59309789.jpg";